<script>
  import AmpelBoxVersionEins from "./AmpelBoxVersionEins.svelte";
  import LineBarMixedChartTwoYAxis from "./LineBarMixedChartTwoYAxis.svelte";
  import LineBarMixedChart from "./LineBarMixedChart.svelte";
  import {
    average_month_data,
    average_month_data_only_visible_months,
    create_target_line,
    divide_by,
    get_labels,
    transform_month_data,
    transform_month_data_average,
  } from "./SixModulesUtils.svelte";
  import { dict_to_average } from "./UtilsBalkenProgress.svelte";
  import { object_values } from "./Utils.svelte";

  export let chart_hoehe_1;
  export let chart_hoehe_2;

  export let redraw;
  export let year = 2090;
  export let churn_rate_target = 0.01;
  export let herd_churn_rate_target = 6;
  export let include_vorjahr;
  export let churn_rate_month_data = {
    "2020-01": 0.2,
    "2020-02": 0.35,
    "2020-03": 0.4,
    "2020-04": 0.5,
    "2020-05": 0.7,
    "2020-06": 0.75,
    "2020-07": 0.4,
    "2020-08": 0.1,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let churn_rate_month_data_vorjahr = {
    "2020-01": 0.1,
    "2020-02": 0.15,
    "2020-03": 0.1,
    "2020-04": 0.15,
    "2020-05": 0.1,
    "2020-06": 0.1,
    "2020-07": 0.2,
    "2020-08": 0.1,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let herd_churn_rate_month_data = {
    "2020-01": 2,
    "2020-02": 3,
    "2020-03": 4,
    "2020-04": 5,
    "2020-05": 7,
    "2020-06": 7,
    "2020-07": 4,
    "2020-08": 1,
  };

  export let herd_churn_rate_month_data_vorjahr = {
    "2020-01": 3,
    "2020-02": 4,
    "2020-03": 2,
    "2020-04": 1,
    "2020-05": 3,
    "2020-06": 3,
    "2020-07": 4,
    "2020-08": 3,
  };

  export let time_modus = "monthly";

  let data = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [0, 0, 0, 0],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
    ],
  };

  let data1 = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [0, 0, 0, 0],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
    ],
  };

  let data2 = {
    labels: ["Jan", "Feb", "Mar", "Apr"],
    datasets: [
      {
        label: "Dataset 1",
        data: [0, 0, 0, 0],
        type: "line",
        borderColor: "#4eb3cf",
        pointRadius: 0,
      },
    ],
  };

  $: {
    churn_rate_month_data,
      churn_rate_month_data_vorjahr,
      herd_churn_rate_month_data,
      herd_churn_rate_month_data_vorjahr,
      time_modus,
      include_vorjahr;
    if (
      churn_rate_month_data &&
      churn_rate_month_data_vorjahr &&
      time_modus &&
      herd_churn_rate_month_data &&
      herd_churn_rate_month_data_vorjahr &&
      churn_rate_target &&
      herd_churn_rate_target
    ) {
      if (time_modus == "monthly") {
        data = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: "Churn Rate Target",
              data: divide_by(create_target_line(time_modus, churn_rate_month_data, churn_rate_target, churn_rate_target), 12),
              type: "line",
              borderColor: "#00B0F0",
              pointRadius: 0,
              yAxisID: "y",
            },
            {
              label: "Boli Churn Rate",
              data: transform_month_data_average(object_values(churn_rate_month_data), time_modus),
              type: "line",
              borderColor: "#455f51",
              pointRadius: 3,
              pointStyle: "rectRot",
              yAxisID: "y",
            },
            {
              label: "Boli Churn Rate Average",
              data: average_month_data_only_visible_months(object_values(churn_rate_month_data)),
              type: "line",
              borderColor: "#455f51",
              pointRadius: 0,
              yAxisID: "y",
              borderDash: [3, 3],
            },
            include_vorjahr
              ? {
                  label: "Boli Churn Rate previous year",
                  data: transform_month_data_average(object_values(churn_rate_month_data_vorjahr), time_modus),
                  type: "line",
                  borderColor: "#bfbfbf",
                  pointRadius: 0,
                  yAxisID: "y",
                }
              : {},
            include_vorjahr
              ? {
                  label: "Boli Churn Rate avg previous year",
                  data: average_month_data(object_values(churn_rate_month_data_vorjahr), time_modus),
                  type: "line",
                  borderColor: "#bfbfbf",
                  pointRadius: 0,
                  yAxisID: "y",
                  borderDash: [3, 3],
                }
              : {},

            {
              label: "Herd Churn rate",
              data: transform_month_data_average(object_values(herd_churn_rate_month_data), time_modus),
              type: "line",
              fill: true,
              borderColor: "#ffc30b",
              backgroundColor: "rgba(255, 195, 11, 0.35)",
              pointRadius: 0,
              borderWidth: 2,
              yAxisID: "y1",
            },
            {
              label: "Herd Churn rate average",
              data: average_month_data_only_visible_months(object_values(herd_churn_rate_month_data), time_modus),
              type: "line",
              borderColor: "#ffe186",
              pointRadius: 0,
              yAxisID: "y1",
              borderDash: [3, 3],
            },
          ],
        };
      }
      if (time_modus == "quaterly" || time_modus == "biannual") {
        data1 = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: "Churn Rate Target",
              data: divide_by(
                create_target_line(time_modus, churn_rate_month_data, churn_rate_target, churn_rate_target),
                time_modus == "quaterly" ? 4 : 2,
              ),
              type: "line",
              borderColor: "#00b0f0",
              pointRadius: time_modus != "biannual" ? 0 : 5,
              pointStyle: time_modus != "biannual" ? "circle" : "triangle",
              yAxisID: "y",
            },

            {
              label: "Churn Rate Average",
              data: average_month_data_only_visible_months(transform_month_data(object_values(churn_rate_month_data), time_modus)),
              type: "line",
              borderColor: "#455f51",
              pointRadius: 0,
              borderDash: [3, 3],
              yAxisID: "y",
            },
            include_vorjahr
              ? {
                  label: "Churn Rate previous year",
                  data: transform_month_data(object_values(churn_rate_month_data_vorjahr), time_modus),
                  type: "bar",
                  borderColor: time_modus == "biannual" ? "#D9D9D9" : "#D9D9D9",
                  pointRadius: 0,
                  yAxisID: "y",
                }
              : {},
            include_vorjahr
              ? {
                  label: "Churn Rate avg previous year",
                  data: average_month_data(transform_month_data(object_values(churn_rate_month_data_vorjahr), time_modus)),
                  type: "line",
                  borderColor: "#D9D9D9",
                  pointRadius: 0,

                  borderDash: [3, 3],
                  yAxisID: "y",
                }
              : {},
            {
              label: "Churn Rate",
              data: transform_month_data(object_values(churn_rate_month_data), time_modus),
              type: "bar",
              borderColor: "#455f51",
              pointRadius: 0,
              yAxisID: "y",
            },
          ],
        };
        data2 = {
          labels: get_labels(year, time_modus),
          datasets: [
            // {
            //   label: 'Herd Churn Rate Target',
            //   data: create_target_line(time_modus, churn_rate_month_data, herd_churn_rate_target, herd_churn_rate_target),
            //   type: 'line',
            //   borderColor: '#00b0f0',
            //   pointRadius: 0,
            //   yAxisID: 'y',
            // },

            include_vorjahr
              ? {
                  label: "Herd churn rate previous year",
                  data: transform_month_data(object_values(herd_churn_rate_month_data_vorjahr), time_modus),
                  type: "bar",
                  borderColor: time_modus == "biannual" ? "#D9D9D9" : "#d9d9d9",
                  pointRadius: 0,
                  yAxisID: "y",
                }
              : {},
            include_vorjahr
              ? {
                  label: "Herd churn rate avg previous year",
                  data: average_month_data(transform_month_data(object_values(herd_churn_rate_month_data_vorjahr), time_modus)),
                  type: "line",
                  borderColor: "#d9d9d9",
                  pointRadius: 0,
                  borderDash: [3, 3],
                  yAxisID: "y",
                }
              : {},
            {
              label: "Herd churn rate",
              data: transform_month_data(object_values(herd_churn_rate_month_data), time_modus),
              type: "bar",
              borderColor: "#ffc30b",
              pointRadius: 0,
              yAxisID: "y",
            },
            {
              label: "Herd churn rate average",
              data: average_month_data_only_visible_months(transform_month_data(object_values(herd_churn_rate_month_data), time_modus)),
              type: "line",
              borderColor: "#ffc30b",
              pointRadius: 0,
              borderDash: [3, 3],
              yAxisID: "y",
            },
          ],
        };
      }

      redraw = false;
      redraw = true;
    }
  }

  //#FRAGE: Soll die Ampel bezug auf das aktuelle Monat oder das ganze Jahr nehmen?
</script>

<div class="row">
  <!-- {divide_by(create_target_line(time_modus, churn_rate_month_data, churn_rate_target, churn_rate_target),((time_modus == 'monthly') ? 12 : ((time_modus == 'quaterly') ? 4 : 2)))} -->

  <div class="col" style="padding-right: 6px;">
    <AmpelBoxVersionEins
      target={churn_rate_target / (year != new Date().getFullYear() ? 1 : 12)}
      current_target={churn_rate_target / (year != new Date().getFullYear() ? 1 : 12)}
      current={dict_to_average(average_month_data(object_values(churn_rate_month_data))) * (year != new Date().getFullYear() ? 12 : 1)}
      unterer_text={"Churn rate " + (year == new Date().getFullYear() ? "p.m.YTD" : "p.a.")}
      circle_size={20}
      do_not_format={true}
      target_muss_darunter_sein={true}
      add_percentage_at_target={true}
      digits={2}
      image={time_modus == "monthly" ? "churn_legend.png" : "1_ HY Revenue_stack.png"}
    />
  </div>
  {#if time_modus != "monthly"}
    <div class="col" style="padding-left: 6px;">
      <AmpelBoxVersionEins
        target={0}
        current={dict_to_average(average_month_data(object_values(herd_churn_rate_month_data))) *
          (year != new Date().getFullYear() ? 12 : 1)}
        unterer_text={"Herd Churn rate " + (year == new Date().getFullYear() ? "p.m.YTD" : "p.a.")}
        circle_size={20}
        without_target={true}
        replace_text={"Herd Churn rate"}
        do_not_format={true}
        add_percentage_at_target={true}
        digits={2}
        image={time_modus == "monthly" ? "1d_Monthly value_3D area_stack.png" : "1c_Quarterly value_stack.png"}
        ampel_weg={true}
      />
    </div>
  {/if}
</div>

<div class="row" style="width:100%; margin: 0px; height:60%;">
  {#if time_modus == "monthly"}
    <div class="col" style="margin:0px; padding:0px; height:0px;">
      <LineBarMixedChartTwoYAxis
        id={Math.floor(Math.random() * 1000000)}
        line_data={data}
        barPercentage={0.9}
        categoryPercentage={0.3}
        type={"bar"}
        orange_second_axis={true}
        percentage_first_axis={true}
        percentage_second_axis={true}
        add_zeichen_1={"% " + "p.m."}
        add_zeichen_2={"% " + "p.m."}
        bind:redraw
      />
    </div>
  {/if}
  {#if time_modus == "quaterly" || time_modus == "biannual"}
    <div class="col-6" style="margin:0px; padding:0px; " bind:clientHeight={chart_hoehe_2}>
      <LineBarMixedChart
        id={Math.floor(Math.random() * 1000000)}
        line_data={data1}
        barPercentage={0.9}
        categoryPercentage={0.7}
        type={"bar"}
        percentage_first_axis={true}
        add_zeichen_1={"% " + (time_modus == "quaterly" ? "p.q." : "p. half-year")}
        bind:redraw
      />
    </div>
    <div class="col-6" style="margin:0px; padding:0px; ">
      <LineBarMixedChart
        id={Math.floor(Math.random() * 1000000)}
        line_data={data2}
        barPercentage={0.9}
        categoryPercentage={0.7}
        type={"bar"}
        percentage_first_axis={true}
        add_zeichen_1={"% " + (time_modus == "quaterly" ? "p.q." : "p. half-year")}
        bind:redraw
      />
    </div>
  {/if}
</div>

<!-- <div class="row">
  <img class="funnel" style="width:100%; margin: 0px; height:20px;" src="/static/img/icons/churn_legend.png" alt="background image" />
</div> -->
<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    left: -70%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 9px;
    white-space: nowrap;
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }

  .funnel {
    max-width: 100%;
  }
</style>
